import { render, staticRenderFns } from "./DualCoreComponents.vue?vue&type=template&id=0d5a5312&"
import script from "./DualCoreComponents.vue?vue&type=script&lang=js&"
export * from "./DualCoreComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports